export default (goods = [], field) => goods.reduce((total, item) => total + +(item[field] || 0), 0);
